// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__10wjc","content":"styles_content__3g-g3","selectAll":"styles_selectAll__3dSE2"};